import { render, staticRenderFns } from "./MotorWithoutVFD.vue?vue&type=template&id=050d1a68&"
import script from "./MotorWithoutVFD.vue?vue&type=script&lang=ts&"
export * from "./MotorWithoutVFD.vue?vue&type=script&lang=ts&"
import style0 from "./MotorWithoutVFD.vue?vue&type=style&index=0&id=050d1a68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports